import "./../extensions/ArrayItemsExchange"
export { }

declare global {
    interface Array<T> {
        exchangeItems(firstItemIndex: number, secondItemIndex: number): Array<any>;
    }
}

Array.prototype.exchangeItems = function (firstItemIndex: number, secondItemIndex: number): Array<any> {
    this[firstItemIndex] = [this[secondItemIndex], this[secondItemIndex] = this[firstItemIndex]][0];
    return this;
}